import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import { buildListQuery, ListQueryOptions, normalizePaginatedListResponse, PaginatedApiResponse } from '../../../services/paginatedList';

export interface AccOperationalType {
  id: number;
  code: string;
  name: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export const useAccOperationalTypes = (searchParams?: string, page = 1, limit = 25, options?: ListQueryOptions) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<PaginatedApiResponse<AccOperationalType> | AccOperationalType[]>(
    `${moduleConfig.module.api.list}${q}`,
    fetcher,
  );
  const normalized = normalizePaginatedListResponse<AccOperationalType>(data, page, limit);
  return { data: normalized.data, total: normalized.total, isLoading, isError: error, mutate };
};

export const useAccOperationalType = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<AccOperationalType>(
    id ? moduleConfig.module.api.detail(id) : null,
    fetcher,
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
